// External libraries
import { createStore } from 'easy-peasy';

// Internal modules
import { storeModel } from './models';
import { $logger } from '../lib/logger';

const appStore = createStore(storeModel);
$logger.info('app_store_created');

// For testing purposes
const createAppStore = options => createStore(storeModel, options);

export { appStore, createAppStore };
